import HomeIcon from "../components/icons/HomeIcon";
import { PageType } from "../const/enums/PageType";

export const NavBarItems = [
  {
    icon: HomeIcon,
    name: "Home",
    link: "/report?alias=mobile",
    page: PageType.Report,
  },
];
